import { useState, useEffect } from "react";

const useDistanceMatrix = (locations) => {
  const [distances, setDistances] = useState([]);
  useEffect(() => {
    if (!window.google || locations.length < 2) return;
    const service = new window.google.maps.DistanceMatrixService();
    const origins = locations
      .slice(0, -1)
      .map(
        (loc) =>
          new window.google.maps.LatLng(loc.coordinates[0], loc.coordinates[1])
      );
    const destinations = locations
      .slice(1)
      .map(
        (loc) =>
          new window.google.maps.LatLng(loc.coordinates[0], loc.coordinates[1])
      );
    service.getDistanceMatrix(
      {
        origins,
        destinations,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === "OK") {
          const newDistances = [];
          response.rows.forEach((row, i) => {
            const element = row.elements[i];
            newDistances.push({
              from: locations[i].address,
              to: locations[i + 1].address,
              distance: element.distance.text,
              duration: element.duration.text,
            });
          });
          setDistances(newDistances);
        }
      }
    );
  }, [locations]);

  const processDistances = (distances) => {
    let totalDistance = 0;
    let cumulativeArray = [];

    distances.forEach((item) => {
      const distanceValue = parseFloat(item.distance.split(" ")[0]); // Extract numeric value
      totalDistance += distanceValue;
      cumulativeArray.push(distanceValue);
    });
    cumulativeArray.unshift(totalDistance);
    return cumulativeArray;
  };
  const result = processDistances(distances);
  return result;
};

export default useDistanceMatrix;
